import { ApolloClient } from '@apollo/client'
import GetNumberOfReservationsByUserId from '../graphql/queries/GetNumberOfReservationsByUserId'

const getNumberOfReservations = async (
  client: ApolloClient<object>,
  userId: string,
): Promise<number | undefined> => {
  try {
    // Calculate 30 minutes ago from now
    const cutoffTime = new Date(Date.now() - 30 * 60 * 1000).toISOString()

    const { data } = await client.query({
      query: GetNumberOfReservationsByUserId,
      variables: { userId, cutoffTime },
      fetchPolicy: 'network-only',
    })

    const signupCount = data?.signup?.aggregate?.count ?? 0
    const joinCount = data?.join?.aggregate?.count ?? 0

    return signupCount + joinCount
  } catch (error) {
    console.error('Error fetching number of reservations:', error)
    return undefined
  }
}

export default getNumberOfReservations
